import { ComponentType } from "react";
import { ConfiguredViewModule, ViewConfiguration, ViewModule, ViewRegistry } from "../types/view";

export const viewRegistry: ViewRegistry = (() => {
  const viewModules = new Map<string, (ViewModule & { config: ViewConfiguration })>();
  const registerView = (view: ViewModule, config: ViewConfiguration) => {
    viewModules.set(view.viewKey, { ...view, config });
  };
  const getViews = <T>(filter?: Partial<ViewConfiguration>) => {
    return new Map(Array.from(viewModules.entries()).filter(([, view]) => {
      return !filter || (Object.entries(filter) as [keyof ViewConfiguration, ViewConfiguration[keyof ViewConfiguration]][])
        .every(([key, value]) => view.config[key] === value);
    })) as T;
  };

  return { registerView, getViews };
})();

export const importView = <T extends object, P>(lazyImport: () => Promise<T>, viewMapper: (module: T) => ComponentType<P>) => {
  return () => lazyImport().then((it) => ({ default: viewMapper(it) }));
};

export const getNavigateTo = (view: ConfiguredViewModule): string => {
  const viewKey = view.viewKey.substring(view.viewKey.lastIndexOf("_") + 1);
  const routerPathPrefix = view.config.type === "modular" ? ["modular"] : [];
  return [routerPathPrefix, viewKey].join("/");
};

export const getRouterPath = (view: ConfiguredViewModule): string => {
  const viewKey = view.viewKey.substring(view.viewKey.lastIndexOf("_") + 1);
  const routerPathPrefix = view.config.type === "modular" ? ["modular"] : [];
  return [...routerPathPrefix, viewKey, "*"].join("/");
};
